import { useSelector } from 'react-redux'

import { RootState } from 'src/Redux'
import { Role } from 'src/Redux/api/authApi.ts'

export const useIsAdmin = (): boolean =>
  useSelector((state: RootState) => state.authentication.user?.role) ===
  Role.ADMIN
